import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromDashboard from './dashboard.reducer';

export const selectDashboardState = createFeatureSelector<fromDashboard.State>(
  fromDashboard.dashboardFeatureKey
);


export const selectOrgDonations = createSelector(
  selectDashboardState,
  (state: fromDashboard.State) => {
    return state.orgDonations 
  }
);

export const selectCampaignReport = createSelector(
  selectDashboardState,
  (state: fromDashboard.State) => {
    return state.campaignReport 
  }
);

export const selectOrgUser = createSelector(
  selectDashboardState,
  (state: fromDashboard.State) => {
    return state.orgUser
  }
);

export const userRecentDonation = createSelector(
  selectDashboardState,
  (state: fromDashboard.State) => {
    return state.recentDonations
  }
);

export const selectUpcomingReminders = createSelector(
  selectDashboardState,
  (state: fromDashboard.State) => {
    return state.upcomingReminders
  }
);
